import { useSelector } from 'react-redux';
import {
  oneErrorOnNotOkFetchye,
  replaceDomainForCacheKey,
  useErrorOnNotOkFetchye,
} from '@americanexpress/fetchye-amex';
import {
  getOneCmsLocaleProductUrl,
  getOneCmsLocaleCommonUrl,
} from '@/selectors/oneCmsSelectors';
import { useRouteParams } from '@/context/routeParamsContext';

export const useOneCmsLocaleProductContent = () => {
  // if (global.mock) {
  //   return {
  //     data: {
  //       body: global.mock.platinumCard,
  //     },
  //   };
  // }
  const { product: routeProduct } = useRouteParams();
  const url = useSelector(getOneCmsLocaleProductUrl(routeProduct));
  return useErrorOnNotOkFetchye(
    url,
    {
      mapKeyToCacheKey: replaceDomainForCacheKey('oneCms'),
    },
    {
      reporting: {
        url,
        collectionMethod: 'useOneCmsLocaleProductContent',
        moduleId: 'travel-lounge-finder-root',
      },
    }
  );
};

export const loadOneCmsLocaleProductContent =
  (product) => async (dispatch, getState) => {
    const url = getOneCmsLocaleProductUrl(product)(getState());
    return dispatch(
      oneErrorOnNotOkFetchye(
        url,
        {
          mapKeyToCacheKey: replaceDomainForCacheKey('oneCms'),
        },
        {
          reporting: {
            url,
            collectionMethod: 'loadOneCmsLocaleProductContent',
            moduleId: 'travel-lounge-finder-root',
          },
        }
      )
    );
  };

export const useOneCmsLocaleCommonContent = () => {
  const url = useSelector(getOneCmsLocaleCommonUrl);
  return useErrorOnNotOkFetchye(
    url,
    {
      mapKeyToCacheKey: replaceDomainForCacheKey('oneCms'),
    },
    {
      reporting: {
        url,
        collectionMethod: 'useOneCmsLocaleCommonContent',
        moduleId: 'travel-lounge-finder-root',
      },
    }
  );
};

export const loadOneCmsLocaleCommonContent = async (dispatch, getState) => {
  const url = getOneCmsLocaleCommonUrl(getState());
  return dispatch(
    oneErrorOnNotOkFetchye(
      url,
      {
        mapKeyToCacheKey: replaceDomainForCacheKey('oneCms'),
      },
      {
        reporting: {
          url,
          collectionMethod: 'loadOneCmsLocaleCommonContent',
          moduleId: 'travel-lounge-finder-root',
        },
      }
    )
  );
};
